import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/product/[id]/ProductDetailClient.tsx");
